import { axiosInstance } from 'boot/axios'

const parseUrl = (state, id) => {
  if (state.relationModel && id) {
    return state.model + '/' + id + '/' + state.relationModel
  } else {
    return id ? state.model + '/' + id : state.model
  }
}

/**
 * Cleans the internal attributes
 * of th given model
 * The internal attributes must have at least one $ symbol
 * @param {*} model
 */
const _clean = model => {
  const cleaned = {}
  for (const key in model) {
    if (key.indexOf('$') < 0) cleaned[key] = model[key]
  }
  return cleaned
}

export async function get({ commit, state }, payload, forceUpdate = false) {
  const id = payload.id
  delete payload.id
  if (state.item && id === state.item.id && !forceUpdate) return state.item

  try {
    const response = await axiosInstance.get(parseUrl(state, id), {
      params: payload
    })
    commit('item', response.data)
    return response.data
  } catch (error) {
    throw new Error(error.message)
  }
}

export function query({ commit, state }, payload) {
  let options = { params: payload }
  return axiosInstance.get(parseUrl(state), options).then(response => {
    commit('items', response.data.items)
    commit('pagination', response.data.pagination)
  })
}

/**
 *  Saves a file item
 * @param {Object} ctx The current context object
 * @param {Object} params The resource params data
 */
export async function save(ctx, params) {
  try {
    const response = await axiosInstance.post('items', _clean(params))
    return response
  } catch (e) {
    throw e
  }
}

/**
 *  Deletes a file item
 * @param {Object} ctx The current context object
 * @param {Object} model The model data
 */
export async function remove(ctx, id) {
  try {
    const response = await axiosInstance.delete(`items/${id}`)
    return response
  } catch (e) {
    throw e
  }
}

export function update({ state }, payload) {
  return axiosInstance.post(parseUrl(state, payload.id), payload)
}
